import { Component, Inject, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FondeadoresService } from '../../../../services/fondeadores.service';
import { ChartDataSets, ChartOptions, ChartType } from 'chart.js';
import { Color } from 'ng2-charts';
//Para PDF
import * as jsPDF from 'jspdf';
//PDF
import * as _html2canvas from "html2canvas";
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

const html2canvas: any = _html2canvas;
declare const require: any;
require('jspdf-autotable');


@Component({
  selector: 'app-simulacion-modal',
  templateUrl: './simulacion-modal.component.html',
  styleUrls: ['./simulacion-modal.component.scss']
})
export class SimulacionModalComponent implements OnInit {

  public esquema_inversion: any = {};
  public interes: number = 0;
  public valor_diario: number = 0;
  public arrayDias: any = [];
  public rendimiento: number = 0;
  public dias: number = 0;
  public tasa_mensual: number = 0;
  public simulacion: boolean = false;
  public isLoading: boolean = false;
  //Para ahorradores
  public esAhorrador: boolean = false;
  public simulacionAhorrador : boolean = false;
  public inversion_ahorrador : any = {};
  //Gráfica de barras
  public barChartOptions: ChartOptions = {};
  
  public barChartLabels: string[];
  public barChartType: ChartType;
  public barChartLegend = true;
  public barChartData: ChartDataSets[];
  public barChartColors: Color[] = [ { backgroundColor: [] }];
  public muestraBarras: boolean = false;

  public chartClicked(e:any): void {
    try {
      
    } catch (err) {}
  }
  public chartHovered(e:any): void {
    console.log(e);
  }

  constructor(
    private fondeadoresService: FondeadoresService,
    public dialogRef: MatDialogRef<SimulacionModalComponent>,
    @Inject (MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    console.log("Data: ",this.data);
    if(this.data.tipo === "inversionista"){
      this.esquema_inversion = this.data.esquema;
      console.log("Entro al componente",this.esquema_inversion);
      this.calcularEsquemaInversion();
    }else if(this.data.tipo === "ahorrador"){
      this.inversion_ahorrador = this.data.esquema_ahorrador;
      console.log("Entro Ahorro: ",this.inversion_ahorrador);
    }
  }

  public recibirFlag(flag:boolean){
    this.simulacion = false;
    this.dialogRef.close({cerrar: true})
  }

  public recibirFlagAhorrador(flag:boolean){
    this.simulacionAhorrador = false;
    this.esAhorrador = true;
    this.dialogRef.close({cerrar: true})
  }

  public calcularEsquemaInversion(){
    this.barChartLabels = [];
    this.barChartType = 'horizontalBar';
    this.barChartLegend = true;
    this.barChartData = [ { data: [], label:''}, { data: [], label:''}];
    this.barChartColors = [ { backgroundColor: '#0081ED' }, { backgroundColor: '#35CA51' }]
    this.muestraBarras = false;

    this.interes = (this.esquema_inversion.monto * this.esquema_inversion.tasa)/100;
    this.valor_diario = (this.interes/30);
    var numMeses = (this.esquema_inversion.plazo/30);
    var barDataInversion: Array <number> = [];
    var barDataRendimiento: Array <number> = [];

    for (let i = 0; i < numMeses; i++) {
      this.tasa_mensual = (this.esquema_inversion.tasa/100);
      this.dias = (i+1)*30;
      this.rendimiento = Math.round(((this.tasa_mensual/30)*this.dias)*this.esquema_inversion.monto);
      
      this.arrayDias.push({ dias: this.dias, rendimiento:this.rendimiento});
      this.barChartLabels.push(this.dias.toString());
      barDataInversion.push(this.esquema_inversion.monto);
      barDataRendimiento.push(this.rendimiento);
    }
   
    this.barChartData[0]=({data:barDataInversion, label: 'Inversión', stack: 'a'});
    this.barChartData[1]=({data:barDataRendimiento, label: 'Rendimiento', stack: 'a'});

    //Asignamos rangos para los valores que se muestran en la gráfica
    let valMin = this.esquema_inversion.monto-100000;
    let valMax = barDataRendimiento[barDataRendimiento.length-1]+25000+this.esquema_inversion.monto;
    console.log("Min: ",valMin," Max: ",valMax);
    
    //Opciones para la gráfica
    this.barChartOptions = {
      responsive: true,
      scales: { 
        xAxes: [{
          ticks: {
            min: valMin,
            max: valMax,
            stepSize: 50000,
            lineHeight:1.5,
            fontSize: 14
          },
          display: true,
          scaleLabel: {
            display: true,
            labelString: 'Inversión',
            lineHeight:3,
            fontSize: 16,
            fontStyle: "bold",
          }
        }], 
        yAxes: [{
          ticks: {
            lineHeight:1.5,
            fontSize: 14
          },
          scaleLabel: {
            display: true,
            labelString: 'Días',
            lineHeight:3,
            fontSize: 16,
            fontStyle: "bold",
          }
        }] 
      },
    }
    
    console.log("BarChart: ", this.barChartData);
    
  }

  public close(){
    this.dialogRef.close({cerrar: true});
  }

  //Función para crear PDF
  //Alternatibva para guardar pdf pero renderiza el html
  public downloadPDF() {
    this.isLoading=true;
    // Extraemos el
    const DATA = document.getElementById('htmlData');
    //const jsPDF = require('jspdf')
    const doc = new jsPDF('p');
    const options = {
      background: 'white',
      scale: 3
    };
    html2canvas(DATA, options).then((canvas) => {

      const img = canvas.toDataURL('image/jpg');
      // Add image Canvas to PDF
      const bufferX = 15;
      const bufferY = 15;
      const imgProps = (doc as any).getImageProperties(img);
      const pdfWidth = doc.internal.pageSize.getWidth() - 2 * bufferX;
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
      doc.addImage(img, 'JPEG', bufferX, bufferY, pdfWidth, pdfHeight, undefined, 'FAST');
      return doc;
    }).then((docResult) => {
      this.isLoading=false;
      docResult.save("Simulacion_Plazo"+this.esquema_inversion.plazo+"dias");
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/administracion/fondeadores/simulacion-esquema-inversion/simulacion-modal/simulacion-modal.component.ts